import DOMPurify from 'dompurify';
import { admindetails } from './defaults';
export const formatprice = (price) => {

    var num = price;
    var commas = num?.toLocaleString("en-US");
    var commas = num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return commas
}

//create an html mark up from json objects
export function createMarkup(html) {
    return {
        __html: DOMPurify.sanitize(html)
    }
}
//currency seperator
export const currencyseperator = (amount) => {
    return amount ? amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0.00;
}

//compute blog read minutes
export function blogminutes(blog) {
    const length = blog?.length;
    const minute = (length / 1000) * 2;
    return Math.round(minute);
}


//calculate distance between coordinates
export function calcdistance(lat1, lon1, lat2, lon2) {
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var lat1 = toRad(lat1);
    var lat2 = toRad(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d?.toFixed(2);
}

function toRad(Value) {
    return Value * Math.PI / 180;
}

//change file to base64
export const getBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        cb(reader.result)
    };
    reader.onerror = function (error) {
        console.log('Error: ', error);
    };
}


//change file from base 64 to png
export const base64tofile = (dataurl, filename) => {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}



//check image file extension
export const checkimageextension = (filename) => {
    const fileextension = filename.split('.').pop();
    if (fileextension !== 'jpg' && fileextension !== 'png' && fileextension !== 'jpeg' && fileextension !== 'JPG' && fileextension !== 'PNG' && fileextension !== 'JPEG') {
        return false;
    } else {
        return true;
    }
}

//set favicon
export function setFavicon(url) {
    const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.type = "image/png";
    link.rel = "icon";
    link.href = url;

    document.getElementsByTagName("head")[0].appendChild(link);
}


//open agent whatsapp
export const gottowhatsapp = (tempmessage) => {
    const message = tempmessage ? tempmessage : 'Hire agent';
    const url = `https://wa.me/${admindetails.phone}/?text=${message}`;

    window.open(url, '_blank');
};


//scroll page to the specified path
export const navigatetopath = (path) => {
    document.getElementById(path).scrollIntoView({ behavior: 'smooth' });
}
